"use strict";
import classNames from "classnames";
const ToolbarLink = React.createClass({
  propTypes: {
    icon: React.PropTypes.string.isRequired,
    enabled: React.PropTypes.bool,
    action: React.PropTypes.func,
    href: React.PropTypes.string,
    active: React.PropTypes.bool,
    title: React.PropTypes.string,
    label: React.PropTypes.string
  },
  render: function render() {
    const { icon, enabled, action, href, title, active, label } = this.props;
    let className = {
      "icon--inactive": !enabled,
      "icon--highlight": active
    };
    const iconClassName = "icon-" + icon;
    className[iconClassName] = true;
    const labelElement = !!label ? /* @__PURE__ */ React.createElement("span", null, label) : "";
    return /* @__PURE__ */ React.createElement(
      "a",
      {
        href,
        onClick: enabled && action,
        title
      },
      /* @__PURE__ */ React.createElement("i", { className: classNames(className) }),
      labelElement
    );
  }
});
export default ToolbarLink;
